// extracted by mini-css-extract-plugin
export default {"status":"tracking_status__peaf2","active":"tracking_active__KDwq8"};